import React from 'react'

const DateGroupHeader = (params) => {
    const { rowNode } = params

    return (
        <div
            style={{
                fontWeight: 600,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                minHeight: '40px',
            }}
        >
            <span style={{ marginLeft: 8 }}>
                {rowNode.groupingKey}
                {` (${rowNode.children.length})`}
            </span>
        </div>
    )
}

export default DateGroupHeader
